import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PhlebotomistDashboard } from '../../components/PhlebotomistDashboard';

const PhlebotomistDashboardPage: FC = () => {
  const { t } = useTranslation('dashboard.PhlebotomistDashboard');

  return (
    <ProfileSideMenuWrapper title={t('title')}>
      <PhlebotomistDashboard />
    </ProfileSideMenuWrapper>
  );
};

export default PhlebotomistDashboardPage;
